import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Menu as MenuIcon, Home } from 'lucide-react';
import CreateModal from '../modals/CreateModal';

// Custom SVG Icons
const HomeIcon = () => (
  <Home size={24} strokeWidth={1.5} />
);

const MADIcon = () => (
  <img 
    src="https://customer-assets.emergentagent.com/job_social-wellness-3/artifacts/90562wwg_hexagons.svg" 
    alt="MAD" 
    style={{ width: 24, height: 24 }}
  />
);

const ImpactIcon = () => (
  <img 
    src="https://customer-assets.emergentagent.com/job_social-wellness-3/artifacts/bp5jpk6k_hexa5.svg" 
    alt="Impact" 
    style={{ width: 24, height: 24 }}
  />
);

const MEIcon = () => (
  <img 
    src="https://customer-assets.emergentagent.com/job_social-wellness-3/artifacts/0tqschig_hexagon.svg" 
    alt="ME" 
    style={{ width: 24, height: 24 }}
  />
);

const BottomNav = ({ active }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const navItems = [
    { key: 'home', icon: HomeIcon, label: 'HOME', path: '/' },
    { key: 'profile', icon: MEIcon, label: 'ME', path: '/profile' },
    { key: 'create', icon: Plus, label: 'Create', isCreate: true },
    { key: 'impact', icon: ImpactIcon, label: 'Impact', path: '/impact' },
    { key: 'menu', icon: MenuIcon, label: 'More', path: '/menu' }
  ];

  return (
    <>
      <motion.div 
        className="bottom-nav" 
        style={{ justifyContent: 'space-around' }}
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          const isCreate = item.isCreate;

          return (
            <motion.button
              key={item.key}
              className={`nav-item ${isActive ? 'active' : ''} ${isCreate ? 'create-btn fab-float' : ''}`}
              onClick={() => isCreate ? setShowModal(true) : navigate(item.path)}
              data-testid={`nav-${item.key}`}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ scale: 1.1, y: -4 }}
              whileTap={{ scale: 0.95 }}
            >
              <motion.div
                animate={isActive ? { scale: [1, 1.1, 1] } : {}}
                transition={{ duration: 0.5 }}
              >
                <Icon />
              </motion.div>
              <span className="nav-label">{item.label}</span>
            </motion.button>
          );
        })}
      </motion.div>

      <AnimatePresence>
        {showModal && (
          <CreateModal onClose={() => setShowModal(false)} />  
        )}
      </AnimatePresence>
    </>
  );
};

export default BottomNav;
